import { render, staticRenderFns } from "./Programmersms.vue?vue&type=template&id=5f4a890c"
import script from "./Programmersms.vue?vue&type=script&lang=js"
export * from "./Programmersms.vue?vue&type=script&lang=js"
import style0 from "./Programmersms.vue?vue&type=style&index=0&id=5f4a890c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports